export function validPersonName(nome: string, numberAllowed: boolean = false): boolean {
  if (!nome) {
    return false;
  }
  if (numberAllowed) {
    return /^([0-9A-Za-zÀ-ÖØ-öø-ÿ']{2,})(.*)(\s[0-9A-Za-zÀ-ÖØ-öø-ÿ']{2,})+$/.test(nome);
  }
  return /^([A-Za-zÀ-ÖØ-öø-ÿ']{2,})(.*)(\s[A-Za-zÀ-ÖØ-öø-ÿ']{2,})+$/.test(nome);
}
